import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../lib/auth";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome back, ${user.name.split(" ")[0]}`);
      nav(user.role === "admin" ? "/admin" : next);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-16 px-6 py-20 lg:grid-cols-2 lg:px-10" data-testid="login-page">
        <div className="hidden lg:block">
          <p className="label-tiny mb-3">Welcome back</p>
          <h1 className="font-serif text-5xl leading-tight text-[#2a2928]">
            Sign in to place your <span className="italic text-[#d08c8c]">order.</span>
          </h1>
          <p className="mt-6 max-w-md text-[#7a7571]">
            Track your hampers &amp; chocolates, save recipient details, and reorder in one click.
          </p>
        </div>

        <form onSubmit={submit} className="rounded-3xl border border-[#e8e2da] bg-white p-10">
          <h2 className="font-serif text-3xl text-[#2a2928]">Sign in</h2>
          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-2 rounded-xl"
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="mt-2 rounded-xl"
                required
              />
            </div>
          </div>
          <Button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="mt-6 w-full rounded-full bg-[#d08c8c] py-6 text-white hover:bg-[#b87a7a]"
          >
            {loading ? "Signing in..." : "Sign in"}
          </Button>
          <p className="mt-6 text-center text-sm text-[#7a7571]">
            New here?{" "}
            <Link to={`/signup?next=${encodeURIComponent(next)}`} data-testid="login-to-signup" className="font-medium text-[#d08c8c] hover:underline">
              Create an account
            </Link>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
}
